import React from 'react';
import PropTypes from 'prop-types';

export const PostMetaDates = ({ date, updated }) => {
  const hasBeenUpdated = updated && updated !== date;

  return (
    <span className="post-date-wrapper">
      <time dateTime={date}>{date}</time>
      {hasBeenUpdated && (
        <span className="date-updated-inline">
          {" \u00B7 "}Updated <time dateTime={updated}>{updated}</time>
        </span>
      )}
    </span>
  );
};

PostMetaDates.propTypes = {
  date: PropTypes.string.isRequired,
  updated: PropTypes.string,
};

export default PostMetaDates;
